export const USER_FEATURE_FOR_PROMOTED_AT_YOUR_DISTRICT_PAGE = 'can_access_promoted_at_your_district_page';

export const USER_FEATURE_FOR_CRUDING_CONTENT_PROMOTION_CONFIGURATION = 'can_crud_content_promotion_configuration';
